import Vue from "vue"

const url = {
    login: "/manage/platform/user/login/by/pwd",
    获取图形验证码: "/manage/sys/captcha",
    outLogin: "/manage/platform/user/outlogin",

    权限列表: "/manage/platform/power/alllist",
    权限添加: "/manage/platform/power/add",
    权限修改: "/manage/platform/power/update",
    权限删除: "/manage/platform/power/delete",
    左侧菜单团队视图: "/manage/platform/user/menu/power",
    用户最大权限树: "/manage/platform/user/power/userAlllist",
    //获取用户已拥有的权限节点id: "/manage/platform/user/select/role/power/pids",

    //获取政务文件树形结构
    获取政务文件树形结构: "/manage/knowledge/tree/by/list",
    政务文件新增: "/manage/knowledge/add",
    政务文件删除: "/manage/knowledge/delete",


    角色列表: "/manage/platform/role/list",
    角色添加: "/manage/platform/role/add",
    角色修改: "/manage/platform/role/update",
    角色删除: "/manage/platform/role/delete",
    角色详情: "/manage/platform/role/detail",


    用户列表: "/manage/platform/user/list",
    用户添加: "/manage/platform/user/add",
    用户修改: "/manage/platform/user/update",
    用户修改密码: "/manage/platform/user/update/password",
    用户删除: "/manage/platform/user/delete",


    查询省市区: "/manage/common/region",
    获取UUID: "/manage/sys/uuid",


    //公司相关
    公司列表: "/manage/company/list",
    添加公司: "/manage/company/add",
    删除公司: "/manage/company/delete",
    更新公司: "/manage/company/update",
    公司禁用: "/manage/company/disable",
    公司启用: "/manage/company/enable",

    //公司员工相关
    员工列表: "/manage/company/employee/list",
    新增公司员工: "/manage/company/employee/add",
    编辑公司员工: "/manage/company/employee/update",
    删除公司员工: "/manage/company/employee/delete",
    修改员工密码: "/manage/company/employee/update/password",


    公司产品表: "/manage/company/list/all",









}

Vue.prototype.$url = url
